import React from 'react'

import Tooltip from 'components/Tooltip'
import InfoIcon from '@mui/icons-material/Info'
import KeyboardAccessible from 'components/KeyboardAccessible'

import styled from 'styled-components'

const InfoIconTooltip = () => {
  const tooltip = 'Data comes from the thermostat and may differ slightly from the Diagnostics Thermostat Runtime History Graph. Variable speed and modulating data are displayed as stages.'

  return (
    <>
      <Tooltip title={tooltip} placement="top">
        <KeyboardAccessible >
          <S.IconContainer>
            <InfoIcon />
          </S.IconContainer>
        </KeyboardAccessible >
      </Tooltip>
    </>
  )
}

const S = {
  IconContainer: styled.div`
    display: inline-block;
    margin-left: 5px;
    margin-top: 10px;
  `
}

export default InfoIconTooltip
